import { MessageBox } from 'element-ui'
import util from '@/libs/util'
import router from '@/router'

let isShowingMessageBox = false

export default {
  install (Vue, options) {
    Vue.prototype.$handleLoginExpired = function () {
      if (isShowingMessageBox) return

      isShowingMessageBox = true
      MessageBox.confirm('登录已过期，请重新登录', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: false
      }).then(() => {
        util.cookies.remove('uuid')
        util.cookies.remove('token')
        util.cookies.remove('areaid')
        util.cookies.remove('roleId')
        util.cookies.remove('username')
        util.cookies.remove('userId')
        router.replace({ name: 'login' })
      }).finally(() => {
        isShowingMessageBox = false
      })
    }
  }
}
